import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPersonCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M22 12q0 5.115-2.615 7.613Q16.885 22 12 22q-4.886 0-7.385-2.387Q2 17.113 2 12 2 2 12 2t10 10m-4.062 6.228a10.7 10.7 0 0 0-2.436-.863 1 1 0 0 0-.633.062c-.883.396-1.865.573-2.87.573-1.003 0-1.985-.177-2.868-.573a1 1 0 0 0-.633-.062c-.87.2-1.685.484-2.436.863C7.233 19.306 9.1 20 12 20s4.767-.694 5.938-1.772M8.986 6.807C9.684 5.915 10.716 5.5 12 5.5s2.316.415 3.014 1.307c.682.872.986 2.13.986 3.693s-.304 2.82-.986 3.693c-.698.892-1.73 1.307-3.014 1.307s-2.316-.415-3.014-1.307C8.304 13.321 8 12.063 8 10.5s.304-2.82.986-3.693'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPersonCircle)
export default ForwardRef
